// extracted by mini-css-extract-plugin
export default {"icon":"style-module__h1Zfc","video":"style-module__RjvHB","videoContainer":"style-module__h_iLE"};